import { HiWrenchScrewdriver } from "react-icons/hi2";

export const SkillsIcon = ({ width, height, color, ...props }) => (
  <HiWrenchScrewdriver
    size={width || height || 16}
    color={color || "currentColor"}
    {...props}
  />
);
